import  home from '../assets/home.jpg';
import Facebook from '../assets/Facebook.svg'
import  Decoration  from '../assets/Decoration.svg';
import formHero from '../assets/formHero.jpg';
import Icon1 from '../assets/Icon1.svg'
import Icon2 from '../assets/Icon2.svg'
import Icon3 from '../assets/Icon3.svg'
import Icon4 from '../assets/Icon4.svg'
import People from '../assets/People.jpg';
import Signature from '../assets/Signature.svg';
import form from '../assets/form.jpg';
import Instagram from '../assets/Instagram.svg';
import BackgroundForm from '../assets/BackgroundForm.jpg';


export default  {
    home,
    Facebook,
    Decoration,
    formHero,
    Icon1,
    Icon2,
    Icon3,
    Icon4,
    People,
    Signature,
    form,
    Instagram,
    BackgroundForm
};